import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  OverviewAnalyticsResponse,
  StudentAnalyticsResponse,
  TeacherAnalyticsResponse,
  RangeParam,
} from '@/types/analytics';

export async function getOverviewAnalytics(
  range: RangeParam = '30d',
  teacherId?: string,
): Promise<OverviewAnalyticsResponse> {
  const params: Record<string, string> = { range };
  if (teacherId) params.teacher_id = teacherId;
  const { data } = await client.get<ApiResponse<OverviewAnalyticsResponse>>(
    '/api/v1/dashboard/analytics/overview',
    { params },
  );
  return data.data;
}

export async function getStudentAnalytics(
  studentId: string,
  range: RangeParam = '30d',
): Promise<StudentAnalyticsResponse> {
  const { data } = await client.get<ApiResponse<StudentAnalyticsResponse>>(
    `/api/v1/dashboard/analytics/students/${studentId}`,
    { params: { range } },
  );
  return data.data;
}

export async function getTeacherAnalytics(
  teacherId: string,
  range: RangeParam = '30d',
): Promise<TeacherAnalyticsResponse> {
  const { data } = await client.get<ApiResponse<TeacherAnalyticsResponse>>(
    `/api/v1/dashboard/analytics/teachers/${teacherId}`,
    { params: { range } },
  );
  return data.data;
}
